import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const ContractListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [typeDict, setTypeDict] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'created_at',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      const contractPartnerId = window.App.urlVars().contractPartnerId;
      if (props.view === 'search' && contractPartnerId) {
        const partnerQuery = `search[partner][operator]==&search[partner][value]=${contractPartnerId}`;
        query += (query.endsWith('?') || query.endsWith('&') ? '' : '&') + partnerQuery;
      }
      if (props.view === 'fulfilment'){
        const fulfilmentQuery = `search[project][operator]==&search[project][value]=${id}&search[type][operator]=%3D&search[type][value]=SUBCONTRACTOR`;
        query += (query.endsWith('?') || query.endsWith('&') ? '' : '&') + fulfilmentQuery;
      }
      apiCall('get', '/api/v2/contract' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setContracts(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getEntityId = (value) => {
    if (!value) return null;
    if (typeof value === 'object') return value.id || null;
    return value;
  };

  const openFulfilmentCreateFromContract = (rowData) => {
    const projectId = props.projectId || id;
    const partnerId = getEntityId(rowData.partner);
    const contractName = rowData.name || rowData.contract_number || '';
    const params = new URLSearchParams();
    params.set('create', 'fulfilment');
    params.set('type', props.fulfillmentType || 'SUBCONTRACTOR');
    params.set('contractId', rowData.id);
    params.set('contractName', contractName);
    params.set('name', contractName);
    params.set('projectId', projectId);
    params.set('return', '/project/project/read/' + projectId);
    if (rowData.currency) {
      params.set('currency', rowData.currency);
    }
    if (partnerId) {
      params.set('partnerId', partnerId);
    }
    if (rowData.partner?.name) {
      params.set('partnerName', rowData.partner.name);
    }
    history.push(`/project/project/read/${projectId}?${params.toString()}`);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {props.view === 'fulfilment' &&
          <Button
            icon="pi pi-plus"
            className="p-button-success p-mr-2"
            tooltip={t('addFulfilment')}
            tooltipOptions={{position: 'left'}}
            onClick={() => openFulfilmentCreateFromContract(rowData)}
          />
        }
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (props.contractContext === 'subcontractor') {
                    history.push(
                      '/project/project/read/' + props.projectId +
                      '?read=contract&contractId=' + rowData.id +
                      '&contractContext=subcontractor&return=' + encodeURIComponent('/project/project/read/' + props.projectId)
                    );
                  } else {
                    history.push('/project/contract/read/' + rowData.id);
                  }
                }}/>
        {localStorage.getItem('roles').toString().includes('role_project_contract_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (props.contractContext === 'subcontractor') {
                      history.push(
                        '/project/project/read/' + props.projectId +
                        '?update=contract&contractId=' + rowData.id +
                        '&contractContext=subcontractor&return=' + encodeURIComponent('/project/project/read/' + props.projectId)
                      );
                    } else {
                      history.push('/project/contract/update/' + rowData.id);
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_project_contract_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm(t('confirmDelete'))) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/contract/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', t('toastDeleteSuccess'));
                          window.App.setState({rerenderContractList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/contract-role')
      .then(response => {
        setTypeDict(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderContractList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={contracts} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                 selectionMode={props.view === 'search' ? "single" : null}
                  onRowDoubleClick={(rowData) => {
                    if (window.App.urlVars().search === 'contract') {
                      let _params = '?';
                      Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                        if (
                          key !== 'search' &&
                          key !== 'contract' &&
                          key !== 'contractId' &&
                          key !== 'contractName' &&
                          key !== 'contractPartnerId' &&
                          key !== 'contractPartnerName'
                        ) {
                          _params += key + '=' + value + '&';
                        }
                      });
                      _params += 'contractId=' + rowData.data.id;
                      _params += '&contractName=' + encodeURIComponent(rowData.data.name || rowData.data.contract_number || '');
                      if (rowData.data.partner?.id) {
                        _params += '&contractPartnerId=' + rowData.data.partner.id;
                        _params += '&contractPartnerName=' + encodeURIComponent(rowData.data.partner.name || '');
                      }
                      history.push(props.backlink + _params);
                    }
                  }}
      >
        {props.view !== 'fulfilment' &&
          <Column field="type" header={t('columnType')} sortable body={(rowData) => {
              const found = typeDict.find(item => item.key === rowData.type);
              return <>{found ? found.value : rowData.type}</>;
          }}></Column>
        }
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="partner.name" header={t('columnPartner')} bodyClassName="col-body-font-bold" sortable filter filterField="partner_name"></Column>
        {props.view !== 'fulfilment' &&
          <Column field="contract_number" header={t('columnProjectNumber2')} bodyClassName="col-body-font-bold" sortable filter></Column>
        }
        <Column field="created_by.name" header={t('columnCreatedBy')} sortable filter filterField="created_by_name"></Column>
        <Column field="project_type.name" header={t('columnProjectType')} sortable filter></Column>
        <Column field="net_amount" header={t('columnContractAmount')} sortable body={(rowData) => {
          return window.App.currencyFormatter(rowData?.currency || 'HUF', rowData.net_amount);
        }}></Column>
        <Column field="vat_rate.label" header={t('columnVat')} sortable></Column>
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        {props.view !== 'search' &&
          <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        }
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ContractListComponent);
